"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Referrer = void 0;
var Referrer;
(function (Referrer) {
    Referrer["HEADER"] = "Header";
    Referrer["EXCLUSIVE_ACCESS"] = "ExclusiveAccessV2";
    Referrer["EXCLUSIVE_ACCESS_HEADER"] = "ExclusiveAccessV2Header";
    Referrer["PERSONALITY_TEST"] = "PersonalityTest";
    Referrer["PERSONALITY_TEST_OLD"] = "PersonalityTest_old";
    Referrer["COUNTRY_TEST"] = "CountryTest";
    Referrer["COUNTRY_TEST_OLD"] = "CountryTest_old";
    Referrer["PERSONAL_UPDATES"] = "PersonalUpdates";
    Referrer["SP_SCHOLARSHIP"] = "SpScholarship";
    Referrer["PROFILE_QUESTIONNAIRES"] = "ProfileQuestionnaires";
    Referrer["PROFILE_QUESTIONNAIRES_POPUP"] = "ProfileQuestionnairesPopup";
    Referrer["WISHLIST"] = "FavouriteStudy";
    Referrer["REVIEWS"] = "Reviews";
    Referrer["REVIEWS_POPUP"] = "ReviewsPopup";
    Referrer["RECOMMENDATIONS"] = "Recommendations";
    Referrer["RECOMMENDATIONS_POPUP"] = "RecommendationsPopup";
    Referrer["GLOBAL_STUDY_AWARDS"] = "GlobalStudyAwards";
    Referrer["ACCOUNT"] = "Account";
    Referrer["OTHER"] = "Other";
    Referrer["COMPARISON_TOOL"] = "ComparisonTool";
    Referrer["EXPERIMENT"] = "Experiment";
    Referrer["GOOGLE_YOLO"] = "GoogleYolo";
    Referrer["ONBOARDING_QUESTIONNAIRE"] = "OnboardingQuestionnaire";
    Referrer["TEST_USER"] = "test-user";
    Referrer["FORM"] = "form";
    Referrer["FREE_TEST_MATERIAL"] = "FreeTestMaterial";
    Referrer["SCHOLARSHIP_TAB"] = "ScholarshipTab";
    Referrer["SCHOLARSHIP_TAB_POPUP"] = "ScholarshipTabPopup";
    Referrer["MY_JOURNEY"] = "MyJourney";
    Referrer["MY_JOURNEY_POPUP"] = "MyJourneyPopup";
    Referrer["MY_JOURNEY_SCHOLARSHIP"] = "MyJourneyScholarship";
    Referrer["COPILOT"] = "Copilot";
    Referrer["UNI_PAGE_PREMIUM_LOCKED_BUTTON"] = "UniPagePremiumLockedButton";
    Referrer["UNI_PAGE_BASIC_LOCKED_BUTTON"] = "UniPageBasicLockedButton";
    Referrer["SCHOLARSHIP_SEARCH_RESULTS"] = "ScholarshipSearchResults";
    Referrer["NFSCHOLARSHIPSPOPUP"] = "NFScholarshipsPopup";
    Referrer["CAREER_DATA_CHART"] = "CareerDataChart";
    Referrer["STUDYPORTALS_SCHOLARSHIP_PAGE"] = "StudyportalsScholarshipPage";
})(Referrer = exports.Referrer || (exports.Referrer = {}));
